<script>
export default {
  methods: {
    localization(key, default_text) {
      return default_text
    },
    handleErrors(err) {
      if (!err || !err.response) return;

      let message = "";
      if (err.response.status == 403)
        message = "You don't have enough permissions for this action";
      else if (err.response.status == 400) message = "Invalid inputs";
      else if (err.response.status == 404) message = "Resource not Found.";
      else if (
        err.response.status == 401 &&
        err.response.data.code === "OAUTH_21"
      ) {
        this.$root.$emit("token_expired");
      } else message = "Oops! Something went wrong.";
    },
  },
};
</script>
